<template>
  <div class="install">
    <h4>{{ partner.name }} - {{ steps[index].title }}</h4>
    <template v-for="(step, stepKey) in steps">
      <template v-if="index === stepKey">
        <component
          :createTransaction="createTransaction"
          :partner_id="partner_id"
          :transaction="transaction"
          :updateOrder="updateOrder"
          @getLimitUser="getLimitUser"
          :limit_user="limit_user"
          :index="index"
          :is="step.key"
          :key="stepKey"
          @next="next"
          :order="order"
          @getHash="getHash"
          :hash="hash"
          @getBuyer="getBuyer"
          :buyer="buyer"
          @getContract="getContract"
          :contract="contract"
          :partner="partner"
        />
      </template>
    </template>
    <button
      v-if="index > 0 && index < 8"
      @click="index = 0"
      class="btn btn-sm btn-info"
    >
      Сбросить
    </button>
  </div>
</template>
<script>
export default {
  props: [
    "order",
    "updateOrder",
    "partner_id",
    "createTransaction",
    "transaction",
    "partner",
  ],
  methods: {
    next(index = 0) {
      if (index < 0) {
        this.$emit("close", true);
      }
      this.index = index;
    },
    getHash(val) {
      this.hash = val;
    },
    getBuyer(val) {
      this.buyer = val;
    },
    getLimitUser(val) {
      this.limit_user = val;
    },
    getContract(val) {
      this.contract = val;
    },
  },
  name: "filter",
  watch: {
    index(val) {
      if (val < 0 || val >= this.steps.length) {
        this.$modal.hide("install");
        this.index = 0;
      }
    },
  },
  components: {
    "client-check": () => import("./ClientCheck"),
    "client-add": () => import("./ClientAdd"),
    "client-verify": () => import("./ClientVerify"),
    "client-push-paymart": () => import("./ClientPushPaymart"),
    "client-card-add": () => import("./ClientCardAdd"),
    "client-card-verify": () => import("./ClientCardVerify"),
    "client-passport-add": () => import("./ClientPassportAdd"),
    "client-guardian-add": () => import("./ClientGuardianAdd"),
    "order-add": () => import("./OrderAdd"),
    "order-client-verify": () => import("./OrderClientVerify"),
    "order-retail-verify": () => import("./OrderRetailVerify"),
    "order-upload-act": () => import("./OrderUploadAct"),
  },
  created() {
    if (this.transaction) {
      this.contract = this.transaction["exchange_id"];
      if (this.transaction["status"] == -1) {
        alert("Заказ был отменен");
        this.$emit("close", true);
      } else if (this.transaction["client_confirmed"] === false) {
        this.index = 0;
      } else if (
        this.transaction["client_confirmed"] === true &&
        this.transaction["system_confirmed"] === false
      ) {
        this.index = 10;
      } else if (
        this.transaction["client_confirmed"] === true &&
        this.transaction["system_confirmed"] === true &&
        this.transaction["akt_uploaded"] === false
      ) {
        this.index = 11;
      } else {
        this.index = 11;
      }
    }
  },
  data() {
    return {
      hash: null,
      buyer: null,
      limit_user: 0,
      contract: null,
      index: 0,
      steps: [
        {
          title: "Проверка клиента", //0
          key: "client-check",
        },
        {
          title: "Добавление клиента", // 1
          key: "client-add",
        },
        {
          title: "Подтверждение номера клиента", //2
          key: "client-verify",
        },
        {
          title: "Добавление клиента в систему PAYMART", //3
          key: "client-push-paymart",
        },
        {
          title: "Добавление пластиковой карты клиента", //4
          key: "client-card-add",
        },
        {
          title: "Подтверждение пластиковой карты клиента", //5
          key: "client-card-verify",
        },
        {
          title: "Добавление паспорта клиента", //6
          key: "client-passport-add",
        },

        {
          title: "Добавление доверителя клиента", //7
          key: "client-guardian-add",
        },
        {
          title: "Добавление заказа в систему PAYMART", //8
          key: "order-add",
        },
        {
          title: "Подтверждение заказа клиентом", //9 -
          key: "order-client-verify",
        },
        {
          title: "Подтверждение заказа", //10 -
          key: "order-retail-verify",
        },
        {
          title: "Загрузка файлов", //11 -
          key: "order-upload-act",
        },
      ],
    };
  },
};
</script>

